import { render, staticRenderFns } from "./ActPrintPayment.vue?vue&type=template&id=005d810a&scoped=true"
import script from "./ActPrintPayment.vue?vue&type=script&lang=js"
export * from "./ActPrintPayment.vue?vue&type=script&lang=js"
import style0 from "./ActPrintPayment.vue?vue&type=style&index=0&id=005d810a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005d810a",
  null
  
)

export default component.exports